import React, { ReactNode, createContext, useContext, useState } from 'react';

import { OfferTab, offerTabs } from '../components/OfferDetailsForm/constants';

type OfferTabContextData = {
  activeTabId: OfferTab;
  setActiveTabId: (tabId: OfferTab) => void;
  isShowingTabErrors: boolean;
  showTabErrors: () => void;
  hideTabErrors: () => void;
};

const OfferTabContext = createContext<OfferTabContextData>({} as OfferTabContextData);

export const OfferTabProvider = ({ children }: { children: ReactNode }) => {
  const [isShowingTabErrors, setIsShowingTabErrors] = useState(false);
  const [activeTabId, setActiveTabId] = useState<OfferTab>(offerTabs.DETAILS);

  return (
    <OfferTabContext.Provider
      value={{
        activeTabId,
        setActiveTabId,
        isShowingTabErrors,
        showTabErrors: () => setIsShowingTabErrors(true),
        hideTabErrors: () => setIsShowingTabErrors(false),
      }}
    >
      {children}
    </OfferTabContext.Provider>
  );
};

export const useOfferTabContext = () => useContext(OfferTabContext);
